








































































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'data', 'activity'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX'
    ])
  },
  components: {
    TitleBar
  }
})
export default class ActivityReport extends Vue {

  get titleStack () {
    return [
      'Отчеты',
      'По активности'
    ]
  }

  public types: any[] = [
    {label: 'Заявка', id: 'deals'},
    {label: 'Смена', id: 'shifts'},
    {label: 'Клиент', id: 'clients'},
    {label: 'Рекламация', id: 'complains'},
    {label: 'Контакт', id: 'contancts'},
    {label: 'Контрагент', id: 'counterparties'},
    {label: 'Сотрудник', id: 'emploayees'},
    {label: 'Пользователь', id: 'people'},
    {label: 'Себестоимость', id: 'prime_costs'},
    {label: 'Продукт', id: 'products'},
    {label: 'Платеж', id: 'payments'},
    {label: 'Словарь активности', id: 'voc_base_activity'},
    {label: 'Словарь колиества сухой смеси', id: 'voc_base_dry_caucity'},
    {label: 'Словарь лого', id: 'voc_base_logos'},
    {label: 'Словарь ротаций', id: 'voc_base_rotates'},
    {label: 'Словарь баз', id: 'voc_bases'},
    {label: 'Словарь глубин колкости', id: 'voc_causticities'},
    {label: 'Словарь характетистик', id: 'voc_characteristic'},
    {label: 'Словарь консистенций на розливе', id: 'voc_consistencies'},
    {label: 'Словарь тар', id: 'voc_containers'},
    {label: 'Словарь корректоров', id: 'voc_correctors'},
    {label: 'Словарь густоты', id: 'voc_densities'},
    {label: 'Словарь упругости', id: 'voc_elasticities'},
    {label: 'Словарь отслоя жира', id: 'voc_fat'},
    {label: 'Словарь сырья', id: 'voc_ingredients'},
    {label: 'Словарь линий', id: 'voc_lines'},
    {label: 'Словарь качестав ПП', id: 'voc_quality_pps'},
    {label: 'Словарь причин закрытия', id: 'voc_reasons'},
    {label: 'Словарь регуляторов', id: 'voc_regulators'},
    {label: 'Словарь выпуска ГП', id: 'voc_release_gps'},
    {label: 'Словарь ролей в смене', id: 'voc_roles'},
    {label: 'Словарь заквасок', id: 'voc_starter_types'},
    {label: 'Словарь мест хранения', id: 'voc_storages'},
  ]

  localFilter = {
    employeeId: null,
    targetDates: [new Date(), new Date()],
    targetName: null,
    targetId: null,
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'delivery_zone_address', this.$route.query.sortDirection || 'asc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.employeeId = (this.$route.query && this.$route.query.employeeId)? this.$route.query.employeeId : null;
    // @ts-ignore
    this.localFilter.targetDates = (this.$route.query && this.$route.query.targetDates) ? [moment(this.$route.query.targetDates[0]).toDate(), moment(this.$route.query.targetDates[1]).toDate()] : [new Date(), new Date()];
    // @ts-ignore
    this.localFilter.targetName = (this.$route.query && this.$route.query.targetName)? this.$route.query.targetName : null;
    // @ts-ignore
    this.localFilter.targetId = (this.$route.query && this.$route.query.targetId)? this.$route.query.targetId : null;
  
    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDates') ? [moment(this.localFilter[key][0]).format('YYYY-MM-DD'), moment(this.localFilter[key][1]).format('YYYY-MM-DD')] : this.localFilter[key]
      return ac;
    }, {});

    this.$router.replace({
      query
    })
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
